import {useCallback} from 'react';

import NiceModal, {useModal} from '@ebay/nice-modal-react';

import {useI18n} from '@yourcoach/i18n';
import {Clickable} from '@yourcoach/shared/uikit/Clickable';

import localAppStore from '@src/context/appStore';

import {NotificationsList} from '../../containers/List';
import * as S from './styles';

export const NotificationsModal = NiceModal.create(() => {
  const {t} = useI18n();
  const modal = useModal();

  const onCloseButtonClick = useCallback(() => {
    localAppStore.setIsTopNotificationsOpen(false);
  }, []);

  const onRequestClose = useCallback(() => {
    localAppStore.setIsTopNotificationsOpen(false);
  }, []);

  return (
    <S.Modal
      disableBodyScroll
      isOpen={modal.visible}
      onAfterClose={modal.remove}
      onRequestClose={onRequestClose}
    >
      <S.Container>
        <S.Header>
          <S.Title>{t('web-app:Notifications.title')}</S.Title>
          <Clickable onClick={onCloseButtonClick}>
            <S.CloseButtonContainer>
              <S.CloseIcon />
            </S.CloseButtonContainer>
          </Clickable>
        </S.Header>
        <S.Content>
          <NotificationsList />
        </S.Content>
      </S.Container>
    </S.Modal>
  );
});
